import 'highcharts'
import 'highcharts/highcharts-more'
window.Highcharts = require('highcharts')
